module.exports = __webpack_public_path__ + "media/images/flags/16/Malta-9fe3506de04c0d8ecd9cf175a7f354da.png";